<template>
  <main class="main main--messaging main--full-height">
    <div class="appointments messaging group group--first-last">
      <div class="appointments__content">
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="c-accent appointments__title">Shared documents</h1>
        <p v-if="documents && documents.length <= 0" class="mt2 pt2 p xlarge fw-regular">You don't have any documents.</p>

        <div class="appointments__header">
          <h3>Document</h3>
          <h3>From</h3>
          <h3>Date</h3>
        </div>

        <div class="appointments__table">  
          <div v-for="document in formatDocuments" :key="document.id" class="table cp" @click="generateFile(document.mime_type, document.id)">
            <div class="table__column df aic">
              <img 
                class="defaultimage"
                :src="Default_image" 
                alt="Default_image" >
              <p class="document-name" :title="document.document_name">{{ document.document_name }}</p>
            </div>

            <div class="table__column mr2">
              <p>{{ document.upload_by }}</p>
            </div>

            <div class="table__column">
              <p>{{ formatTime(document.upload_date) }}</p>
            </div>
          </div>   
        </div>
      </div>
    </div> 
    <module-modal
      :modal="modalData"
      @close="openModal = false"
      v-show="openModal"
    >

      <template slot="modal-body">
        <div>
          <p class="pt">Please log in from a laptop or desktop to download this file.</p>
        </div>
      </template>

      <template slot="modal-footer">
        <module-button @click.native="openModal = false">Close</module-button>
      </template>
    </module-modal>
    
  </main>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
const data = JSON.parse(localStorage.getItem('updateUser'));

import ModuleModal from 'components/Modal';

import Default_image from 'images/icons/Default_image.png';

export default {
  name: 'view-documents',

  components: {
    ModuleModal,
  },

  data() {
    return {
      openModal: false,
      Default_image,
      modalData: {
        title: 'Unable to download file',
      },
    };
  },

  computed: {
    ...mapGetters('appointment', [
      'documents',
    ]),
    ...mapGetters('app', ['org']),

    formatDocuments() {
      // if (this.$route.name === 'documents') {
      //   return this.documents && this.documents.filter((doc) => doc.upload_by === `${data.first_name} ${data.last_name}` );
      // }
      return this.documents;
    },
  },

  methods: {
    ...mapActions('appointment', [
      'requestPatientDocumentList',
      'requestPatientDocument',
    ]),

    formatTime(time) {
      return moment(time).format('MMM. D, YYYY [at] h:mm A z');
    },

    generateThumbnail(type, uri) {
      return `data:${type};base64,${uri.replace(/(\r\n|\n|\r)/gm, '')}`;
    },

    generateFile(type, id) {
      const userAgent = window.navigator.userAgent;

      if (type === 'application/pdf' && (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i))) {
        this.openModal = true;
      } else {
        this.requestPatientDocument({ id: data.md_live.user.id, documentId: id })
          .then((res) => {
            const uri = res.data.data;
            const type = res.data.mime_type;
            const name = res.data.document_name;

            const link = document.createElement('a');
            link.setAttribute('download', name);
            link.setAttribute('target', '_blank');
            link.href = `data:${type};base64,${uri.replace(/(\r\n|\n|\r)/gm, '')}`;
            document.body.appendChild(link);
            link.click();
            link.remove();
          })
          .catch((err) => console.error(err));
      }
    },
  },

  created() {
    if (data.md_live.user.id) this.requestPatientDocumentList(data.md_live.user.id);
  },
};
</script>



// WEBPACK FOOTER //
// Documents.vue?e84c75c6